import Axios from 'axios';
import { API_ENDPOINT } from './env';
import { msalInstance } from '../../index';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

const API = Axios.create({
  baseURL: API_ENDPOINT,
  timeout: 120000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Use an interceptor to dynamically set the Authorization header on each request
API.interceptors.request.use(
  async (config) => {
    // Skip MSAL token acquisition in development environment
    if (import.meta.env.DEV) {
      return config;
    }

    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      try {
        const response = await msalInstance.acquireTokenSilent({
          scopes: ['User.Read'],
          account: accounts[0],
        });
        config.headers.Authorization = `Bearer ${response.accessToken}`;
      } catch (error) {
        // If consent is required or token expired, redirect to login
        if (error instanceof InteractionRequiredAuthError) {
          console.warn('User interaction required');
          // Don't redirect if already on login page (causes refresh loop)
          if (window.location.pathname !== '/login') {
            // Preserve redirect URL before clearing session storage
            const redirectUrl = sessionStorage.getItem('redirectAfterLogin');
            sessionStorage.clear();
            if (redirectUrl) {
              sessionStorage.setItem('redirectAfterLogin', redirectUrl);
            }
            localStorage.removeItem('impersonatedAuthId');
            window.location.href = '/login';
          }
          return Promise.reject(error);
        }
        console.error('Failed to acquire token silently:', error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptor to handle 401 unauthorized errors
API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // If backend returns 401 Unauthorized, redirect to login
    if (error.response?.status === 401) {
      console.warn('Unauthorized');
      // Don't redirect if already on login page (causes refresh loop)
      if (window.location.pathname !== '/login') {
        // Preserve redirect URL before clearing session storage
        const redirectUrl = sessionStorage.getItem('redirectAfterLogin');
        sessionStorage.clear();
        if (redirectUrl) {
          sessionStorage.setItem('redirectAfterLogin', redirectUrl);
        }
        localStorage.removeItem('impersonatedAuthId');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  },
);

export default API;
